import { collection, getDocs,  query, where, addDoc, doc, updateDoc, deleteDoc } from "firebase/firestore";
import { ref, deleteObject,getDownloadURL } from "firebase/storage";

import { db , storage} from "../../../firebase";

const collectionName = "clientes"; // Nombre de la colección en Firestore
const tipoDocumentoCollectionName = "TipoDocumento";
const papeleriaCollectionName = "papeleria";

// Obtener todos los clientes
const getClientes = async () => {
  try {
    const clientesCollection = collection(db, collectionName);
    const snapshot = await getDocs(clientesCollection);
    const clientes = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    return clientes;
  } catch (error) {
    console.error("Error al obtener los clientes:", error);
    throw error;
  }
};

// Obtener tipos de documentos
const getTiposDocumentos = async () => {
  try {
    const tiposCollection = collection(db, tipoDocumentoCollectionName);
    const snapshot = await getDocs(tiposCollection);
    const tipos = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    return tipos;
  } catch (error) {
    console.error("Error al obtener tipos de documentos:", error);
    throw error;
  }
};

// Asignar papelería al cliente
const asignarPapeleria = async (codigoCliente, tiposDocumentos) => {
  try {
    const papeleriaCollection = collection(db, papeleriaCollectionName);
    const batch = tiposDocumentos.map(async (tipoDoc) => {
      await addDoc(papeleriaCollection, {
        CodigoCliente: codigoCliente,
        CodigoTipoDoc: tipoDoc.id,
        NombreDocumento: tipoDoc.Nombre,
        Descripcion: tipoDoc.Descripcion,
        DocumentoAdjunto: null,
        FechaVencimiento: null,
        Estado: false, // Documento no adjuntado
      });
    });
    await Promise.all(batch);
    console.log("Papelería asignada correctamente.");
  } catch (error) {
    console.error("Error al asignar papelería:", error);
    throw error;
  }
};

// Insertar un nuevo cliente
const insertarCliente = async (cliente) => {
  try {
    // Eliminar el campo `id` si existe en el objeto
    const { id, ...clienteData } = cliente;

    const clientesCollection = collection(db, collectionName);
    const docRef = await addDoc(clientesCollection, clienteData);

    // Obtener tipos de documentos y asignar papelería
    const tiposDocumentos = await getTiposDocumentos();
    await asignarPapeleria(docRef.id, tiposDocumentos);

    return { success: true, id: docRef.id };
  } catch (error) {
    console.error("Error al insertar cliente:", error);
    throw error;
  }
};


// Actualizar un cliente existente
const actualizarCliente = async (cliente) => {
  try {
    const clienteRef = doc(db, collectionName, cliente.id);
    await updateDoc(clienteRef, cliente);
    return { success: true };
  } catch (error) {
    console.error("Error al actualizar cliente:", error);
    throw error;
  }
};

// Eliminar un cliente
const eliminarCliente = async (codigoCliente) => {
  try {
    const papeleriaCollection = collection(db, papeleriaCollectionName);
    const q = query(papeleriaCollection, where("CodigoCliente", "==", codigoCliente));
    const querySnapshot = await getDocs(q);

    for (const docSnap of querySnapshot.docs) {
      const documentoData = docSnap.data();
      const documentoId = docSnap.id;

      if (documentoData.DocumentoURL) {
        const filePath = `papeleria/${codigoCliente}/${documentoData.NombreDocumento}`;
        const fileRef = ref(storage, filePath);

        try {
          // Verificar si el archivo existe
          await getDownloadURL(fileRef);

          // Eliminar el archivo
          await deleteObject(fileRef);
          console.log(`Archivo eliminado: ${filePath}`);
        } catch (error) {
          if (error.code === "storage/object-not-found") {
            console.warn(`El archivo no existe: ${filePath}`);
          } else {
            throw error;
          }
        }
      }

      // Eliminar el documento en Firestore
      const docRef = doc(db, papeleriaCollectionName, documentoId);
      await deleteDoc(docRef);
      console.log(`Documento eliminado en Firestore: ${documentoId}`);
    }

    // Eliminar el cliente en Firestore
    const clienteRef = doc(db, collectionName, codigoCliente);
    await deleteDoc(clienteRef);
    console.log(`Cliente eliminado: ${codigoCliente}`);

    return { success: true };
  } catch (error) {
    console.error("Error al eliminar cliente y sus documentos relacionados:", error);
    throw error;
  }
};
export { getClientes, insertarCliente, actualizarCliente, eliminarCliente, getTiposDocumentos };
